export default {
  // Admin - Customers List
  'admin.customers.title': 'Customer Management',
  'admin.customers.subtitle': 'Manage registered customers and their accounts',
  'admin.customers.search': 'Search customers...',
  'admin.customers.filter.all': 'All',
  'admin.customers.filter.customer': 'Customer',
  'admin.customers.filter.admin': 'Admin',
  'admin.customers.filter.superAdmin': 'Super Admin',
  'admin.customers.columns.name': 'Name',
  'admin.customers.columns.email': 'Email',
  'admin.customers.columns.company': 'Company',
  'admin.customers.columns.country': 'Country',
  'admin.customers.columns.role': 'Role',
  'admin.customers.columns.joined': 'Joined',
  'admin.customers.columns.status': 'Status',
  'admin.customers.columns.actions': 'Actions',
  'admin.customers.status.active': 'Active',
  'admin.customers.status.inactive': 'Inactive',
  'admin.customers.noResults': 'No customers found',
  'admin.customers.total': '{{count}} customers',
  'admin.customers.viewDetail': 'View Details',

  // Admin - Customer Detail
  'admin.customerDetail.back': 'Back to Customers',
  'admin.customerDetail.title': 'Customer Details',
  'admin.customerDetail.profile': 'Profile',
  'admin.customerDetail.company': 'Company Info',
  'admin.customerDetail.addresses': 'Addresses',
  'admin.customerDetail.quotations': 'Quotations',
  'admin.customerDetail.orders': 'Orders',
  'admin.customerDetail.aiPreviews': 'AI Previews',
  'admin.customerDetail.noCompany': 'No company registered',
  'admin.customerDetail.noAddresses': 'No addresses registered',
  'admin.customerDetail.noQuotations': 'No quotations found',
  'admin.customerDetail.noOrders': 'No orders found',
  'admin.customerDetail.noPreviews': 'No AI previews found',
  'admin.customerDetail.roleChange': 'Change Role',
  'admin.customerDetail.roleChangeHint': 'Only super admin can change roles',
  'admin.customerDetail.save': 'Save Changes',
  'admin.customerDetail.basicInfo': 'Basic Information',
  'admin.customerDetail.contactInfo': 'Contact Information',
};